import { cn } from '@/lib/utils'

import { Skeleton, useBannerSliderVariants } from '../../../Theme'

import type { BannerSkeletonProps } from '../../types'

/**
 * BannerSkeleton - Loading state for banner slider
 */
export function BannerSkeleton({ className }: BannerSkeletonProps) {
  const { bannerSectionVariants, bannerSkeletonVariants } = useBannerSliderVariants()

  return (
    <section className={bannerSectionVariants()}>
      <Skeleton className={cn(bannerSkeletonVariants(), 'w-full', className)} />
    </section>
  )
}
